// Applied at the ClerkProvider level so security/reverification modals match Qubiq auth screens.
export const clerkGlobalAppearance = {
  elements: {
    card: {
      borderRadius: "5px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.28)",
    },
    modalContent: {
      borderRadius: "5px",
      overflow: "hidden",
    },
    formButtonPrimary: {
      borderRadius: "5px",
      backgroundColor: "#ffcf00",
      color: "#121216",
      boxShadow: "0px 3px 0 #d38200",
    },
    formFieldInput: { borderRadius: "5px" },
    formFieldInput__password: { borderRadius: "5px" },
    formFieldInputShowPasswordButton: { borderRadius: "5px" },
    otpCodeFieldInput: { borderRadius: "5px" },
    formSecondaryAction: { borderRadius: "5px" },
    formResendCodeLink: { borderRadius: "5px" },
  },
};
